const errorTypes = {
  email: {
    message: 'Password cannot be your email',
    failureType: 'password - email'
  },
  carvana: {
    message: "Password cannot contain the word 'carvana'",
    failureType: 'password - carvana'
  }
};

const validatePassword = (password: string, email: string) => {
  const lowerCasePassword = password.toLowerCase();
  const lowerCaseEmail = email.toLowerCase();

  if (lowerCasePassword.includes('carvana')) {
    return {
      passwordIsInvalid: true,
      errorMessage: errorTypes.carvana.message,
      failureType: errorTypes.carvana.failureType
    };
  }
  if (lowerCasePassword === lowerCaseEmail) {
    return {
      passwordIsInvalid: true,
      errorMessage: errorTypes.email.message,
      failureType: errorTypes.email.failureType
    };
  }
  return {
    passwordIsInvalid: false
  };
};

export default validatePassword;
